import { render, staticRenderFns } from "./procedimento_valor.vue?vue&type=template&id=b5d0c742"
import script from "./procedimento_valor.vue?vue&type=script&lang=js"
export * from "./procedimento_valor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports